var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlaylistWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28128 6.96851C7.8239 6.96851 7.45312 7.33928 7.45312 7.79666V14.4219C7.45312 14.8793 7.8239 15.2501 8.28128 15.2501H15.7347C16.1921 15.2501 16.5628 14.8793 16.5628 14.4219V7.79666C16.5628 7.33928 16.1921 6.96851 15.7347 6.96851H8.28128ZM10.7655 12.5458L13.25 11.1114L10.7655 9.67698L10.7655 12.5458Z",
    fill: "url(#paint0_linear_859_37359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28128 6.96851C7.8239 6.96851 7.45312 7.33928 7.45312 7.79666V14.4219C7.45312 14.8793 7.8239 15.2501 8.28128 15.2501H15.7347C16.1921 15.2501 16.5628 14.8793 16.5628 14.4219V7.79666C16.5628 7.33928 16.1921 6.96851 15.7347 6.96851H8.28128ZM10.7655 12.5458L13.25 11.1114L10.7655 9.67698L10.7655 12.5458Z",
    fill: "white",
    fillOpacity: 0.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 1.23555,
    x2: 11.6579,
    y2: 1.23555,
    stroke: "url(#paint1_linear_859_37359)",
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 1.23555,
    x2: 11.6579,
    y2: 1.23555,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 4.54414,
    x2: 11.6579,
    y2: 4.54414,
    stroke: "url(#paint2_linear_859_37359)",
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 4.54414,
    x2: 11.6579,
    y2: 4.54414,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 8.68501,
    x2: 5.86079,
    y2: 8.68501,
    stroke: "url(#paint3_linear_859_37359)",
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.764451,
    y1: 8.68501,
    x2: 5.86079,
    y2: 8.68501,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5289,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_859_37359",
    x1: 9.01999,
    y1: 7.84444,
    x2: 17.2844,
    y2: 9.92952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_859_37359",
    x1: 2.13664,
    y1: 2.10577,
    x2: 3.45128,
    y2: 5.85147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_859_37359",
    x1: 2.13664,
    y1: 5.41436,
    x2: 3.45128,
    y2: 9.16006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_859_37359",
    x1: 1.13954,
    y1: 9.55523,
    x2: 3.07148,
    y2: 12.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlaylistWhite);
export default __webpack_public_path__ + "static/media/ic_playlist_white.ad9d2fe88fa07fd085cd4c45283c3435.svg";
export { ForwardRef as ReactComponent };